import { call, select } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchPosTrackingMethods as fetchPosTrackingMethodsRoutine,
  fetchPosTrackingMethodLocations as fetchPosTrackingMethodLocationsRoutine,
  fetchPosLocationsForTrackingMethod as fetchPosLocationsForTrackingMethodRoutine,
  createPosLocationsForTrackingMethod as createPosLocationsForTrackingMethodRoutine,
  deletePosLocationsForTrackingMethod as deletePosLocationsForTrackingMethodRoutine
} from './routines';
import { getIsSaving } from '../../selectors/pos/trackingMethodLocations';
import history from '../../../../routes/history';
import pagePathToUrl from '../../../../helpers/pagePathToUrl';
import { settingsPosTrackingMethodLocationsPath } from '../../../../routes/Paths';

export const fetchPosTrackingMethods = ({ payload: qs }) =>
  sagaRoutineRequest(fetchPosTrackingMethodsRoutine, {
    request: () => call(Api.fetchTrackingMethodOptions, { qs })
  });

export const fetchPosTrackingMethodLocations = ({ payload: qs }) =>
  sagaRoutineRequest(fetchPosTrackingMethodLocationsRoutine, {
    request: () => call(Api.fetchPosTrackingMethodLocations, { qs })
  });

export const fetchPosLocationsForTrackingMethod = ({
  payload: trackingMethodId
}) =>
  sagaRoutineRequest(fetchPosLocationsForTrackingMethodRoutine, {
    request: () =>
      call(Api.fetchPosLocationsForTrackingMethod, trackingMethodId)
  });

export const createPosLocationsForTrackingMethod = ({
  payload: { id, body }
}) =>
  sagaRoutineRequest(createPosLocationsForTrackingMethodRoutine, {
    request: () => call(Api.createPosLocationsForTrackingMethod, { id, body }),
    *success() {
      yield toastr.success(
        'Success',
        'POS Tracking Method locations successfully saved.'
      );
      history.push(
        pagePathToUrl(settingsPosTrackingMethodLocationsPath, { id })
      );
    }
  });

export const deletePosLocationsForTrackingMethod = ({
  payload: { id, body }
}) =>
  sagaRoutineRequest(deletePosLocationsForTrackingMethodRoutine, {
    request: () => call(Api.deletePosLocationsForTrackingMethod, { id, body }),
    *success() {
      const isSaving = yield select(getIsSaving);
      if (!isSaving) {
        yield toastr.success(
          'Success',
          'POS Tracking Method locations successfully saved.'
        );
        history.push(
          pagePathToUrl(settingsPosTrackingMethodLocationsPath, { id })
        );
      }
    }
  });
